import LibraryApi from '../api/LibraryApi';
import LibraryConstants from '../constants/LibraryConstants';

function getLibrary(locale) {
  return {
    types: [
      LibraryConstants.LIBRARY_REQUEST,
      LibraryConstants.LIBRARY_SUCCESS,
      LibraryConstants.LIBRARY_FAILURE
    ],
    apiRequest: (state, client) => LibraryApi.getLibrary(client, locale)
  };
}

export default {
  getLibrary
};



// WEBPACK FOOTER //
// ./app/actions/LibraryActions.js